module.exports = __webpack_public_path__ + "static/media/templates.932dea25.png";


//////////////////
// WEBPACK FOOTER
// ./src/Jiggle/Design/img/templates.png
// module id = 275
// module chunks = 0